import type { ImplyResponse } from "@ppb/betslip-core";
import type { CombinationResult } from "@flutter-global/uki-channels-http-clients/src/clients/BetCombinationEngineService/BetCombinationEngineService";
import type {
  NETWORK__PLACE_SBK_BET_IN_PROGRESS,
  NETWORK__SBK_COMBINATIONS_UPDATE_FAILURE,
  NETWORK__SBK_COMBINATIONS_UPDATE_IN_PROGRESS,
  NETWORK__SBK_COMBINATIONS_UPDATE_SUCCESS,
  SportsbookImplyError,
  UI__BETSLIP_SBK_DEPOSIT_TO_CONFIRM_BET_CLICK,
  UI__BETSLIP_SBK_DEPOSIT_TO_PLACE_BET_CLICK,
} from "@ppb/tbd-store/actions/betslip";
import type { BetslipObbPlaceBetResponseData } from "@ppb/tbd-store/state/betslip/Betslip.types";
import type { BettingGroup } from "@ppb/tbd-store/state/betting/sportsbook-betting/SportsbookBetting.types";
import type { URN } from "../../types";
import type { BetslipSportsbookOpportunity } from "../../contract/types";
import type {
  BetslipSportsbookOneLineLegsRequest,
  BetslipSportsbookSelection,
  BetslipSportsbookSelectionsRequest,
} from "../../contract/inbound/sportsbook-requests/sportsbook-request-events";
import type {
  BetslipSportsbookSelectionsRequestOutcome,
  BetslipSportsbookSelectionsRequestSettlement,
} from "../../contract/outbound/sportsbook-request-settled/sportsbook-request-settled-event";
import type { BetslipSportsbookOneLineLegsRequestSettlement } from "../../contract/outbound/sportsbook-one-line-legs-request-settled/sportsbook-one-line-legs-request-settled-event";
import type { BetslipSbkSwitchPromptMetadata } from "../../contract/outbound/tagging/betslip-tagging-event";

// The constants imported from @ppb/tbd-store/actions/betslip are still observed by the host's tagging and
// otel middlewares, so they stay declared there until those observers move to bus events.

export const UI__BETSLIP_SBK_REMOVE_BOOSTED_COMBINATION_CLICK = "UI/BETSLIP_SBK_REMOVE_BOOSTED_COMBINATION_CLICK";
export const UI__BETSLIP_SBK_STAKE_INPUT_CHANGE = "UI/BETSLIP_SBK_STAKE_INPUT_CHANGE";
export const UI__BETSLIP_SBK_CONFIRM_CAST_BET_CHANGE = "UI__BETSLIP_SBK_CONFIRM_CAST_BET_CHANGE";
export const UI__BETSLIP_SBK_BONUS_BALL_TOGGLE = "UI/BETSLIP_SBK_BONUS_BALL_TOGGLE";

export const UI__BETSLIP_DISMISS_BET_BUILDER_MULTIS_NOTIFICATION_ACTION =
  "BETSLIP/DISMISS_BET_BUILDER_MULTIS_NOTIFICATION_ACTION";

export const BETSLIP__PERSISTED_STATE_RESTORED = "BETSLIP/PERSISTED_STATE_RESTORED";
export const BETSLIP__SBK_SELECTIONS_APPLY = "BETSLIP/SBK_SELECTIONS_APPLY";
export const BETSLIP__SBK_SELECTIONS_REQUESTED = "BETSLIP/SBK_SELECTIONS_REQUESTED";
export const BETSLIP__SBK_SELECTIONS_CONFIRMED = "BETSLIP/SBK_SELECTIONS_CONFIRMED";
export const BETSLIP__SBK_ONE_LINE_LEGS_REQUESTED = "BETSLIP/SBK_ONE_LINE_LEGS_REQUESTED";
export const BETSLIP__SBK_ONE_LINE_LEGS_CONFIRMED = "BETSLIP/SBK_ONE_LINE_LEGS_CONFIRMED";
export const BETSLIP__SBK_ONE_LINE_LEGS_APPLY = "BETSLIP/SBK_ONE_LINE_LEGS_APPLY";
export const BETSLIP__SBK_SELECTIONS_DECLINED = "BETSLIP/SBK_SELECTIONS_DECLINED";
export const BETSLIP__SBK_ONE_LINE_LEGS_DECLINED = "BETSLIP/SBK_ONE_LINE_LEGS_DECLINED";
export const BETSLIP__SBK_SELECTIONS_SETTLED = "BETSLIP/SBK_SELECTIONS_SETTLED";
export const BETSLIP__SBK_ONE_LINE_LEGS_SETTLED = "BETSLIP/SBK_ONE_LINE_LEGS_SETTLED";
export const BETTING__SBK_ENSURE_SELECTION_DATA = "BETTING/SBK_ENSURE_SELECTION_DATA";
export const BETTING__SBK_ENSURE_SELECTION_DATA_SUCCESS = "BETTING/SBK_ENSURE_SELECTION_DATA_SUCCESS";
export const BETTING__SBK_ENSURE_SELECTION_DATA_ERROR = "BETTING/SBK_ENSURE_SELECTION_DATA_ERROR";
export const BETTING__OBB_SBK_CLEAR_ACTION = "BETTING/OBB_SBK_CLEAR_ACTION";
export const BETTING__OBB_SBK_KEEP_ACTION = "BETTING/OBB_SBK_KEEP_ACTION";
export const MODULES__SBK_BETTING_LOADED = "MODULES/SBK_BETTING_LOADED";
export const MODULES__EXC_BETTING_LOADED = "MODULES/EXC_BETTING_LOADED";
export const UI__BETSLIP_SET_LAST_SUCCESSFUL_STAKE = "BETSLIP/SET_LAST_SUCCESSFUL_STAKE";

export const UI__OPEN_COMBINATIONS_LIST = "UI/OPEN_COMBINATIONS_LIST";
export const NETWORK__FETCH_COMBINATIONS_LIST_IN_PROGRESS = "NETWORK/FETCH_COMBINATIONS_LIST_IN_PROGRESS";
export const NETWORK__FETCH_COMBINATIONS_LIST_SUCCESS = "NETWORK/FETCH_COMBINATIONS_LIST_SUCCESS";
export const NETWORK__FETCH_COMBINATIONS_LIST_FAILURE = "NETWORK/FETCH_COMBINATIONS_LIST_FAILURE";

export const UI__BETSLIP_OBB_RECEIPT_PANEL_DONE_CLICK = "UI/BETSLIP_OBB_RECEIPT_PANEL_DONE_CLICK";
export const UI__BETSLIP_OBB_MAX_PAYOUT_NOTIFICATION_URL_CLICK = "UI/BETSLIP_OBB_MAX_PAYOUT_NOTIFICATION_URL_CLICK";

export const NETWORK__OBB_PLACE_BET_IN_PROGRESS = "NETWORK/OBB_PLACE_BET_IN_PROGRESS";
export const NETWORK__OBB_PLACE_BET_FAILURE = "NETWORK/OBB_PLACE_BET_FAILURE";
export const NETWORK__OBB_QUOTES_UPDATE_IN_PROGRESS = "NETWORK/OBB_QUOTES_UPDATE_IN_PROGRESS";
export const NETWORK__OBB_IMPLY_BETS_IN_PROGRESS = "NETWORK/OBB_IMPLY_BETS_IN_PROGRESS";
export const NETWORK__OBB_IMPLY_BETS_REQUEST_FAILURE = "NETWORK/OBB_IMPLY_BETS_REQUEST_FAILURE";
export const NETWORK__OBB_FETCH_LEG_QUOTES_FAILURE = "NETWORK/OBB_FETCH_LEG_QUOTES_FAILURE";

export type BetslipSportsbookRemoveBoostedCombinationClick = {
  type: typeof UI__BETSLIP_SBK_REMOVE_BOOSTED_COMBINATION_CLICK;
  payload: {
    legIds: string[];
  };
};

export type BetslipSportsbookStakeInputChange = {
  type: typeof UI__BETSLIP_SBK_STAKE_INPUT_CHANGE;
  payload: {
    combinationId: string;
    stake?: number;
  };
};

export type BetslipSportsbookConfirmCastBetChange = {
  type: typeof UI__BETSLIP_SBK_CONFIRM_CAST_BET_CHANGE;
  payload: {
    castId: string;
    combinationId: string;
  };
};

export type SportsbookSelectionsChange = Extract<BetslipSportsbookSelectionsRequestOutcome, "ADDED" | "REMOVED">;

type SportsbookSelectionsApplyRequest = {
  runnerUrns: string[];
  group: BettingGroup;
  opportunity?: BetslipSportsbookOpportunity;
};

export type BetslipSbkSelectionsApplyAction = {
  type: typeof BETSLIP__SBK_SELECTIONS_APPLY;
  payload:
    | (SportsbookSelectionsApplyRequest & { change: "ADDED"; runnerUrnsToAdd: string[] })
    | (SportsbookSelectionsApplyRequest & { change: "REMOVED"; legIdsToRemove: string[] });
};

export type BetslipSbkSelectionsRequestedAction = {
  type: typeof BETSLIP__SBK_SELECTIONS_REQUESTED;
  payload: BetslipSportsbookSelectionsRequest;
};

export type BetslipSbkSelectionsConfirmedAction = {
  type: typeof BETSLIP__SBK_SELECTIONS_CONFIRMED;
  payload: BetslipSportsbookSelectionsRequest;
};

export type BetslipSbkOneLineLegsRequestedAction = {
  type: typeof BETSLIP__SBK_ONE_LINE_LEGS_REQUESTED;
  payload: BetslipSportsbookOneLineLegsRequest;
};

export type BetslipSbkOneLineLegsConfirmedAction = {
  type: typeof BETSLIP__SBK_ONE_LINE_LEGS_CONFIRMED;
  payload: BetslipSportsbookOneLineLegsRequest;
};

export type BetslipSbkOneLineLegsApplyAction = {
  type: typeof BETSLIP__SBK_ONE_LINE_LEGS_APPLY;
  payload: BetslipSportsbookOneLineLegsRequest & { legIdsToRemove: string[] };
};

export type BetslipSbkSelectionsDeclinedAction = {
  type: typeof BETSLIP__SBK_SELECTIONS_DECLINED;
  payload: BetslipSportsbookSelectionsRequest;
};

export type BetslipSbkOneLineLegsDeclinedAction = {
  type: typeof BETSLIP__SBK_ONE_LINE_LEGS_DECLINED;
  payload: BetslipSportsbookOneLineLegsRequest;
};

export type BetslipSbkSelectionsSettledAction = {
  type: typeof BETSLIP__SBK_SELECTIONS_SETTLED;
  payload: BetslipSportsbookSelectionsRequestSettlement;
};

export type BetslipSbkOneLineLegsSettledAction = {
  type: typeof BETSLIP__SBK_ONE_LINE_LEGS_SETTLED;
  payload: BetslipSportsbookOneLineLegsRequestSettlement;
};

export type SportsbookEnsurePayload = {
  requestId: string;
  group: BettingGroup;
  selections: BetslipSportsbookSelection[];
  marketUrns?: string[];
  selectionIds?: number[];
  allowPartialAdd?: boolean;
};

export type BetslipSbkEnsureSelectionDataAction = {
  type: typeof BETTING__SBK_ENSURE_SELECTION_DATA;
  payload: SportsbookEnsurePayload;
};

export type BetslipSbkEnsureSelectionDataSuccessAction = {
  type: typeof BETTING__SBK_ENSURE_SELECTION_DATA_SUCCESS;
  payload: SportsbookEnsurePayload;
};

export type BetslipSbkEnsureSelectionDataErrorAction = {
  type: typeof BETTING__SBK_ENSURE_SELECTION_DATA_ERROR;
  payload: { requestId: string };
};

export type BettingObbSbkClearAction = {
  type: typeof BETTING__OBB_SBK_CLEAR_ACTION;
  payload?: {
    cardUrn?: URN;
    eventName?: string;
    runnerUrn?: URN;
    group?: BetslipSbkSwitchPromptMetadata["group"];
    actionLabel?: string;
  };
};

export type BettingObbSbkKeepAction = {
  type: typeof BETTING__OBB_SBK_KEEP_ACTION;
  payload: {
    clickedOutside: boolean;
    cardUrn?: URN;
    eventName?: string;
    runnerUrn?: URN;
    group?: BetslipSbkSwitchPromptMetadata["group"];
    actionLabel?: string;
  };
};

export type BettingSbkModuleLoadedAction = {
  type: typeof MODULES__SBK_BETTING_LOADED;
};

export type BetslipBetBuilderMultisDismissNotificationAction = {
  type: typeof UI__BETSLIP_DISMISS_BET_BUILDER_MULTIS_NOTIFICATION_ACTION;
};

export type BetslipPersistedStateRestoredAction = {
  type: typeof BETSLIP__PERSISTED_STATE_RESTORED;
  payload: {
    group?: BettingGroup;
    isCollapsed?: boolean;
    showMaxPayoutNotification?: boolean;
    lastSuccessfulStake?: number;
  };
};

export type BetslipSetLastSuccessfulStakeAction = {
  type: typeof UI__BETSLIP_SET_LAST_SUCCESSFUL_STAKE;
  payload: {
    stake: number;
  };
};

export type PlaceSportsbookBetInProgressAction = {
  type: typeof NETWORK__PLACE_SBK_BET_IN_PROGRESS;
};

export type SportsbookCombinationsUpdateInProgressAction = {
  type: typeof NETWORK__SBK_COMBINATIONS_UPDATE_IN_PROGRESS;
};

export type SportsbookCombinationsUpdateSuccessAction = {
  type: typeof NETWORK__SBK_COMBINATIONS_UPDATE_SUCCESS;
  payload: {
    combinations: ImplyResponse.ImplyBetsResult[];
  };
};

export type SportsbookCombinationsUpdateFailureAction = {
  type: typeof NETWORK__SBK_COMBINATIONS_UPDATE_FAILURE;
  payload: {
    error: SportsbookImplyError;
  };
};

export type BetslipSportsbookBonusBallToggleAction = {
  type: typeof UI__BETSLIP_SBK_BONUS_BALL_TOGGLE;
  payload: {
    isSelected: boolean;
  };
};

export type BetslipSportsbookDepositToConfirmBetClick = {
  type: typeof UI__BETSLIP_SBK_DEPOSIT_TO_CONFIRM_BET_CLICK;
};

export type BetslipSportsbookDepositToPlaceBetClick = {
  type: typeof UI__BETSLIP_SBK_DEPOSIT_TO_PLACE_BET_CLICK;
};

export type OpenCombinationsListAction = {
  type: typeof UI__OPEN_COMBINATIONS_LIST;
  payload: {
    combinationId: string;
    maxCombinations: number;
  };
};

export type FetchCombinationsListInProgressAction = {
  type: typeof NETWORK__FETCH_COMBINATIONS_LIST_IN_PROGRESS;
};

export type FetchCombinationsListSuccessAction = {
  type: typeof NETWORK__FETCH_COMBINATIONS_LIST_SUCCESS;
  payload: {
    combinationId: string;
    response: CombinationResult;
  };
};

export type FetchCombinationsListFailureAction = {
  type: typeof NETWORK__FETCH_COMBINATIONS_LIST_FAILURE;
  payload: {
    error: string;
  };
};

export type BetslipObbReceiptPanelDoneClickAction = {
  type: typeof UI__BETSLIP_OBB_RECEIPT_PANEL_DONE_CLICK;
};

export type BetslipObbMaxPayoutNotificationUrlClickAction = {
  type: typeof UI__BETSLIP_OBB_MAX_PAYOUT_NOTIFICATION_URL_CLICK;
  payload: {
    url: string;
  };
};

export type PlaceObbBetInProgressAction = {
  type: typeof NETWORK__OBB_PLACE_BET_IN_PROGRESS;
};

export type PlaceObbBetFailureAction = {
  type: typeof NETWORK__OBB_PLACE_BET_FAILURE;
  payload: {
    betPlacementResponse: BetslipObbPlaceBetResponseData;
  };
};

export type ImplyObbBetsInProgressAction = {
  type: typeof NETWORK__OBB_IMPLY_BETS_IN_PROGRESS;
};

export type ObbQuotesUpdateInProgressAction = {
  type: typeof NETWORK__OBB_QUOTES_UPDATE_IN_PROGRESS;
};

export type ObbQuotesUpdateFailureAction = {
  type: typeof NETWORK__OBB_FETCH_LEG_QUOTES_FAILURE;
  payload: {
    error: unknown;
  };
};

export type ObbImplyBetsRequestFailureAction = {
  type: typeof NETWORK__OBB_IMPLY_BETS_REQUEST_FAILURE;
  payload: {
    error: unknown;
  };
};
